























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class GalaPowerBar extends Vue {
  @Prop(Number) readonly powerBarPercent!: number;

  hideSparkleMotion = false;

  @Watch('powerBarPercent')
  handlePowerChange() {
    setTimeout(() => {
      this.hideSparkleMotion = true;
    }, 2000);
  }
}
